
import type { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import ThankYouPage from '../pages/ThankYou';
import PricingPage from '../pages/pricing/page';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesListPage = lazy(() => import('../pages/servicos/page'));
const SolucoesPage = lazy(() => import('../pages/solucoes/page'));
const InfraestruturaPage = lazy(() => import('../pages/infraestrutura/page'));
const RecursosPage = lazy(() => import('../pages/recursos/page'));
const LocacaoOutsourcingPage = lazy(() => import('../pages/services/locacao-outsourcing/page'));
const TerceirizacaoTIPage = lazy(() => import('../pages/services/terceirizacao-ti/page'));
const TrabalhoRemotoPage = lazy(() => import('../pages/services/trabalho-remoto/page'));
const AreaClientePage = lazy(() => import('../pages/area-cliente/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PoliticaPage = lazy(() => import('../pages/politica/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-600">Carregando...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<PageLoader />}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/sobre',
    element: (
      <Suspense fallback={<PageLoader />}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: '/planos',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PricingPage />
      </Suspense>
    ),
  },
  {
    path: '/solucoes',
    element: (
      <Suspense fallback={<PageLoader />}>
        <SolucoesPage />
      </Suspense>
    ),
  },
  {
    path: '/infraestrutura',
    element: (
      <Suspense fallback={<PageLoader />}>
        <InfraestruturaPage />
      </Suspense>
    ),
  },
  {
    path: '/recursos',
    element: (
      <Suspense fallback={<PageLoader />}>
        <RecursosPage />
      </Suspense>
    ),
  },
  {
    path: '/servicos',
    element: (
      <Suspense fallback={<PageLoader />}>
        <ServicesListPage />
      </Suspense>
    ),
  },
  {
    path: '/servicos/locacao-outsourcing',
    element: (
      <Suspense fallback={<PageLoader />}>
        <LocacaoOutsourcingPage />
      </Suspense>
    ),
  },
  {
    path: '/servicos/terceirizacao-ti',
    element: (
      <Suspense fallback={<PageLoader />}>
        <TerceirizacaoTIPage />
      </Suspense>
    ),
  },
  {
    path: '/servicos/trabalho-remoto',
    element: (
      <Suspense fallback={<PageLoader />}>
        <TrabalhoRemotoPage />
      </Suspense>
    ),
  },
  {
    path: '/area-cliente',
    element: (
      <Suspense fallback={<PageLoader />}>
        <AreaClientePage />
      </Suspense>
    ),
  },
  {
    path: '/contato',
    element: (
      <Suspense fallback={<PageLoader />}>
        <ContatoPage />
      </Suspense>
    ),
  },
  {
    path: '/obrigado',
    element: (
      <Suspense fallback={<PageLoader />}>
        <ThankYouPage />
      </Suspense>
    ),
  },
  {
    path: '/politica',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PoliticaPage />
      </Suspense>
    ),
  },
  {
    path: '/cookies',
    element: (
      <Suspense fallback={<PageLoader />}>
        <CookiesPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<PageLoader />}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
